import React from "react"
import { useState } from "react"

interface CustomCheckbox {
  id?: string
  name?: string
  inputRef?: React.Ref<any>
  required?: boolean
  defaultChecked?: boolean
  value?: boolean
  onChange?: (value: boolean) => void
  onValueChange?: (value: boolean) => void
  onClick?: () => void
  className?: string
  labelClassName?: string
  children?: React.ReactNode
  disabled?: boolean
  noMarginRight?: boolean
  alignTop?: boolean
}

const CustomCheckbox = ({
  id,
  name,
  inputRef,
  defaultChecked,
  onChange,
  onClick,
  className,
  labelClassName,
  children,
  disabled,
  noMarginRight,
  alignTop,
}: CustomCheckbox) => {
  const [isChecked, setIsChecked] = useState(defaultChecked || false)

  const handleChange = (newValue: boolean) => {
    setIsChecked(newValue)
    onChange?.(newValue)
  }

  return (
    <div
      className={`flex ${alignTop ? "" : "items-center"} my-1 ${
        noMarginRight ? "" : "mr-4"
      } ${className ?? ""}`}
    >
      <label
        className={`toggle ${disabled ? "opacity-50" : ""}`}
        onClick={() => onClick?.()}
      >
        <input
          id={id}
          ref={inputRef}
          checked={isChecked}
          defaultChecked={defaultChecked}
          name={name}
          className="toggle__input"
          onChange={(e) => handleChange(e.target.checked)}
          type="checkbox"
          disabled={disabled}
        />
        <span className="toggle__label" style={{ paddingLeft: 16 }}>
          {/* <span className="toggle__text">{children}</span> */}
        </span>
      </label>
      {children && (
        <span
          className={`pl-4 ${disabled ? "opacity-50" : "cursor-pointer"} ${
            labelClassName ?? ""
          }`}
          onClick={() => {
            if (!disabled) {
              handleChange(!isChecked)
            }
          }}
        >
          {children}
        </span>
      )}
    </div>
  )
}

export const RawCheckbox = CustomCheckbox

export default React.forwardRef((props: any, ref) => (
  <CustomCheckbox {...props} inputRef={ref} />
))
